import classNames from 'classnames';

import {IconButton} from 'shells/button/icon-button/icon-button';
import {ChevronLeftIcon, ChevronRightIcon} from 'shells/icon';

import styles from './pinned-expand-button.module.css';

type Props = {
    isCollapsed: boolean;
    onStateChange: (isCollapsed: boolean) => void;
};

export function PinnedExpandButton(props: Props) {
    const {isCollapsed, onStateChange} = props;

    const toggleState = () => {
        onStateChange(!isCollapsed);
    };

    return (
        <IconButton
            size='small'
            tooltipText='Toggle navigation'
            icon={!isCollapsed ? ChevronLeftIcon : ChevronRightIcon}
            onClick={toggleState}
            // @ts-expect-error
            className={classNames(styles['expand-button'], {
                [styles['expand-button--collapsed']]: isCollapsed,
            })}
        />
    );
}
